import { FC } from 'react'

const Footer: FC = () => {
  return <></>
}

export default Footer
